/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";

import OpdTvDisplay from "./newScreensWithApi/OpdTvDisplay";
import networkList from "../../constants/networkList";
import postService from "../../services/httpService";

class TvScreensPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tvScreenExist: 'no'
    };
  }

  async componentDidMount() {
    await this.getMasterTvDisplays();
  }

  async getMasterTvDisplays(){
    let search = window.location.search
    let params = new URLSearchParams(search);
    let uid = params.get('uid');

    const currenthref = window.location.pathname;
    let thisTvScreen = currenthref.split('/')

    const { getMasterTvDisplays } = networkList;

    await postService(getMasterTvDisplays, "POST", { data: { uid : uid } }).then((res) => {
      if (res.status) {
        let tvScreens = res.data.map(a => a.tv_display_name)

        if(tvScreens.includes(thisTvScreen[2])) {
          this.setState((state) => ({
            tvScreenExist : 'yes'
          }));
        }
      }
    })
  }

  BodyRender() {
    let { slug } = this.props.match.params;
    const { menuList } = this.props;
    var page = null;

    if(this.state.tvScreenExist === 'yes'){
      slug = this.state.tvScreenExist;
      
      switch (slug) {
        case "yes":
          page = (
            <OpdTvDisplay {...this.props} {...this.state} menuList={menuList} />
          );
          break;
        default:
          break;
      }
      return page;
    }
    else{
      return page;
    }
  }

  render() {
    return <div className="custom-container p-0 mt-0">{this.BodyRender()}</div>;
  }
}

export default TvScreensPage;
